import { LoadScript } from "@react-google-maps/api";
import {
  AutoComplete,
  Breadcrumb,
  Col,
  Collapse,
  Form,
  Input,
  Row,
  Spin,
} from "antd";
import "antd/dist/antd.min.css";
// import { debounce } from "lodash";
import React, {  useEffect, useRef, useState } from "react";
import { Trans, useTranslation } from "react-i18next";
import "react-phone-input-2/lib/style.css";
import { Link, useNavigate, useParams } from "react-router-dom";
import { getRequest, patchRequest, postRequest } from "../../axios";
import ButtonField from "../../common/htmlComponents/ButtonField";
import "../../styles/Main.scss";
import { SuccessNotificationMsg } from "../../utils/Notifications";

const Addwarehouse = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const libraries = ["places"];
  // const formRef = useRef();
  const formRef = useRef();
  const [form] = Form.useForm();

  const { id } = useParams();
  const CompanyId = id ? atob(id) : null;
  const [options, setOptions] = useState([]);
  const { Panel } = Collapse;
  // const [sizepolicecheck, setSizepolicecheck] = useState(null);
  // const [sizeuploaddrivinglicense, setsizeuploaddrivinglicense] =
  //   useState(null);
  // const [fileLink, setFileLink] = useState(null);
  // const [fileLinkpolice_check, setFileLinkpolice_check] = useState(null);

  const initialState = {
    company_street_address: "",
    suburb: null,
    state: null,
    postcode: null,
    additional_details: null,
  };
  const [state, setState] = useState(initialState);
  const [btnLoading, setBtnLoading] = useState(false);
  const [apiLoading, setapiloading] = useState(false);
  // const [checked, setChecked] = useState(false);
  // const [loading, setLoading] = useState(false);
  const [reload, setReload] = useState(false);
  // const handleCheckboxChange = (e) => {
  //   setChecked(e.target.checked);
  //   setState((prevState) => ({
  //     ...prevState,
  //     term_condition_accept: e.target.checked,
  //   }));
  // };

  //const urls = state?.driving_license;
  // const urlone = state.document_url;

  // let filenamelicense = "";
  // // let filenameadhar = "";
  // try {
  //   if (fileLink) {
  //     filenamelicense = urls.split("/").pop();
  //   }
  // } catch (e) {
  //   filenamelicense = "";
  // }

  // const url = state?.police_check;

  // let filenamepolice_check = "";
  // try {
  //   if (fileLinkpolice_check) {
  //     filenamepolice_check = url.split("/").pop();
  //   }
  // } catch (e) {
  //   filenamepolice_check = "";
  // }

  // useEffect(() => {
  //   const companyGetById = async () => {
  //     setapiloading(true);
  //     try {
  //       const apiResponse = await getRequest(`warehouse/${CompanyId}/`);

  //       if (apiResponse?.data?.success) {
  //         const companyData = apiResponse.data.data;
  //         // Set state with initial values
  //         const depoAddresses =
  //           companyData.depo_address?.map((e) => ({
  //             depo_street_address: e?.depo_street_address,
  //             depo_suburb: e?.depo_suburb,
  //             depo_state: e?.depo_state,
  //             depo_postcode: e?.depo_postcode,
  //             depo_additional_details: e?.depo_additional_details,
  //           })) || [];
  //         setState({
  //           ...apiResponse?.data?.data,
  //           company_street_address:
  //             apiResponse?.data?.data?.street_address,
  //           suburb: apiResponse?.data?.data?.suburb,
  //           state: apiResponse?.data?.data?.state,
  //           postcode

  //             apiResponse?.data?.data?.additional_detail,
  //         });
 
  //         formRef.current.setFieldsValue({
  //           ...apiResponse?.data?.data,

  //           // depo_address: apiResponse?.data?.data?.depo_address?.map((e) => ({
  //           //   street_address: e?.street_address,
  //           //   suburb: e?.suburb,
  //           //   state: e?.state,
  //           //   postcode: e?.postcode,
  //           //   additional_details: e?.additional_details,
  //           // })),
  //           // depo_address: apiResponse?.data?.data?.depo_address?.map((e, index) => ({
  //           //   [`street_address${index}`]: e?.street_address,
  //           //   [`suburb_${0}`]: e?.suburb,
  //           //   [`state_${0}`]: e?.state,
  //           //   [`postcode_${0}`]: e?.postcode,
  //           //   [`additional_details_${0}`]: e?.additional_details,
  //           // })),
  //         });

  //         formRef.current.setFieldsValue({
  //           ...companyData,
  //           company_number: String(companyData.company_number),
  //           depo_address: depoAddresses,
  //         });

  //         setapiloading(false);
  //       }
  //     } catch (error) {
  //       setapiloading(false);
  //     }
  //   };
  //   if (CompanyId !== null) {
  //     companyGetById();
  //   }
  // }, [CompanyId, t, reload]);

  useEffect(() => {
    const companyGetById = async () => {
      setapiloading(true);
      try {
        const apiResponse = await getRequest(`warehouse/${CompanyId}/`);
        if (apiResponse?.data?.success) {
          const companyData = apiResponse.data.data;
          // Set state with initial values
          const depoAddresses =
            companyData.depo_address?.map((e) => ({
              depo_street_address: e?.depo_street_address,
              depo_suburb: e?.depo_suburb,
              depo_state: e?.depo_state,
              depo_postcode: e?.depo_postcode,
              depo_additional_details: e?.depo_additional_details,
            })) || [];
          setState({
            ...apiResponse?.data?.data,

            street_address: apiResponse?.data?.data?.street_address,
            suburb: apiResponse?.data?.data?.suburb,
            state: apiResponse?.data?.data?.state,
            postcode: apiResponse?.data?.data?.postcode,
            additional_details: apiResponse?.data?.data?.additional_details,
            // depo_address: apiResponse?.data?.data?.depo_address?.map((e) => ({
            //   street_address: e?.street_address,
            //   suburb: e?.suburb,
            //   state: e?.state,
            //   postcode: e?.postcode,
            //   additional_details: e?.additional_details,
            // })),
            depo_address: depoAddresses,
          });

          formRef.current.setFieldsValue({
            ...apiResponse?.data?.data,
            company_name: apiResponse?.data?.data?.company_name,
            company_email: apiResponse?.data?.data?.company_email,
            company_number: String(apiResponse?.data?.data?.company_number),
            company_contact_name: apiResponse?.data?.data?.company_contact_name,
            company_abn_no: apiResponse?.data?.data?.company_abn_no,
            company_note: apiResponse?.data?.data?.company_note,
            // depo_address: apiResponse?.data?.data?.depo_address?.map((e) => ({
            //   street_address: e?.street_address,
            //   suburb: e?.suburb,
            //   state: e?.state,
            //   postcode: e?.postcode,
            //   additional_details: e?.additional_details,
            // })),
            // depo_address: apiResponse?.data?.data?.depo_address?.map((e, index) => ({
            //   [`street_address${index}`]: e?.street_address,
            //   [`suburb_${0}`]: e?.suburb,
            //   [`state_${0}`]: e?.state,
            //   [`postcode_${0}`]: e?.postcode,
            //   [`additional_details_${0}`]: e?.additional_details,
            // })),
          });

          formRef.current.setFieldsValue({
            ...companyData,
            company_number: String(companyData.company_number),
            depo_address: depoAddresses,
          });

          // setWeightSizeFieldValue(depoAddresses);
          setapiloading(false);
        }
      } catch (error) {
        setapiloading(false);
      }
    };
    if (CompanyId !== null) {
      companyGetById();
    }
  }, [CompanyId, t, reload]);
  const handleSelect = (value) => {
    const selected = options.find((option) => option.value === value);
    if (selected && selected.place_id) {
      const service = new window.google.maps.places.PlacesService(
        document.createElement("div")
      );
      service.getDetails({ placeId: selected.place_id }, (place, status) => {
        if (
          status === window.google.maps.places.PlacesServiceStatus.OK &&
          place
        ) {
          setState((prevstate) => ({
            ...prevstate,
            street_address: place.formatted_address,
            suburb:
              place.address_components.find((ac) =>
                ac.types.includes("locality")
              )?.long_name || "",
            state:
              place.address_components.find((ac) =>
                ac.types.includes("administrative_area_level_1")
              )?.short_name || "",
            postcode:
              place.address_components.find((ac) =>
                ac.types.includes("postal_code")
              )?.long_name || "",
          }));
          form.setFieldsValue({
            street_address: place.formatted_address,
            suburb:
              place.address_components.find((ac) =>
                ac.types.includes("locality")
              )?.long_name || "",
            state:
              place.address_components.find((ac) =>
                ac.types.includes("administrative_area_level_1")
              )?.short_name || "",
            postcode:
              place.address_components.find((ac) =>
                ac.types.includes("postal_code")
              )?.long_name || "",
          });
        }
      });
    }
  };

  // const handleSearch = useCallback(
  //   debounce((value) => {
  //     // setLoading(true);

  //     const service = new window.google.maps.places.AutocompleteService();

  //     if (value !== "") {
  //       service.getPlacePredictions({ input: value }, (predictions, status) => {
  //         if (
  //           status === window.google.maps.places.PlacesServiceStatus.OK &&
  //           predictions
  //         ) {
  //           setOptions(
  //             predictions.map((prediction) => ({
  //               value: prediction.description,
  //               place_id: prediction.place_id,
  //             }))
  //           );
  //           // setLoading(false);
  //         } else {
  //           setOptions([]);
  //           // setLoading(false);
  //         }
  //       });
  //     } else {
  //       setOptions([]);
  //       // setLoading(false);
  //       setState((prevstate) => ({
  //         ...prevstate,
  //         street_address: "",
  //         suburb: "",
  //         state: "",
  //         postcode: "",
  //       }));
  //       form.setFieldsValue({
  //         street_address: "",
  //         suburb: "",
  //         state: "",
  //         postcode: "",
  //       });
  //     }
  //   }, 300),
  //   []
  // );
  // const handleSearch = useCallback(
  //   debounce((value) => {
  //     const service = new window.google.maps.places.AutocompleteService();
  
  //     if (value !== "") {
  //       service.getPlacePredictions({ input: value }, (predictions, status) => {
  //         if (
  //           status === window.google.maps.places.PlacesServiceStatus.OK &&
  //           predictions
  //         ) {
  //           setOptions(
  //             predictions.map((prediction) => ({
  //               value: prediction.description,
  //               place_id: prediction.place_id,
  //             }))
  //           );
  //         } else {
  //           setOptions([]);
  //         }
  //       });
  //     } else {
  //       setOptions([]);
  //       setState((prevstate) => ({
  //         ...prevstate,
  //         street_address: "",
  //         suburb: "",
  //         state: "",
  //         postcode: "",
  //       }));
  //       form.setFieldsValue({
  //         street_address: "",
  //         suburb: "",
  //         state: "",
  //         postcode: "",
  //       });
  //     }
  //   }, 300),
  //   [setOptions, setState, form] // Include dependencies here
  // );
  // const handleInputChange = (e) => {
  //   let { name, value } = e.target;
  //   setState({ ...state, [name]: value });
  // };

  // const handleKeyPress = (e) => {
  //   // Allow only lowercase letters, numbers, and specific symbols
  //   const allowedChars = /^[a-z0-9@._-]*$/; // Add other allowed characters as needed
  //   if (!allowedChars.test(e.key) && e.key !== "Backspace") {
  //     e.preventDefault();
  //   }
  // };

  const handleSubmit = async () => {
    const payload = {
      // employe_id: state.employe_id,

      street_address: state.street_address,
      suburb: state.suburb,
      state: state.state,
      postcode: state.postcode,
      additional_details: state.additional_details,
      // address: "201 Sussex Street, Sydney NSW 2000",
    };
    try {
      setBtnLoading(true);
      let response;

      if (CompanyId === null) {
        response = await postRequest("warehouse/", payload);
      } else {
        response = await patchRequest(`warehouse/${CompanyId}/`, payload);
      }
      if (response.data.success) {
        SuccessNotificationMsg(
          CompanyId === null
            ? t("warehouse_added_successfully")
            : t("warehouse_updated_successfully")
        );
        // setState(initialState);
        // formRef.current.setFieldsValue(initialState);
        setBtnLoading(false);
        setReload(!reload);

        navigate("/warehouse");
      }
    } catch (error) {
      // if (CompanyId === null) {
      //   ErrorNotificationMsg(
      //     t("error_in_adding_company")
      //   );
      // }
      // if (CompanyId !== null && !error?.message) {
      //   ErrorNotificationMsg(
      //     t("error_in_updating_company")
      //   );
      // }
      setBtnLoading(false);
    }
  };

  return (
    <>
      <div className="ListingTopBar">
        <div className="pagenamewrap">
          <div className="pagename">
            {CompanyId ? <h3>Edit Warehouse</h3> : <h3>Add Warehouse</h3>}

            <Breadcrumb className="Breadcrumb-Sec">
              <Breadcrumb.Item>
                <Link to="/dashboard">{t("home")}</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>
                <Link to="/warehouse"> {t("Manage warehouse")}</Link>
              </Breadcrumb.Item>

              <Breadcrumb.Item>
                {CompanyId ? "Edit warehouse" : "Add warehouse"}
              </Breadcrumb.Item>
            </Breadcrumb>
          </div>
        </div>
      </div>

      <section className="grid-sec FormSection Container">
        <div className="FormBody">
          <Form ref={formRef} form={form}>
            <LoadScript
              googleMapsApiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY}
              libraries={libraries}
            >
              <Spin spinning={apiLoading}>
                {/* <Form autoComplete="off" form={form} > */}

                <Collapse defaultActiveKey={["1"]}>
                  <Panel header="1. Warehouse Details" key="1">
                    <Row gutter={[10]}>
                      {/* <Col
                  xs={24}
                  sm={24}
                  md={12}
                  lg={6}
                  xl={6}
                  className="TextFeild gutter-row"
                >
                  <InputField
                    name="address"
                    label={t("pl_address")}
                    placeholder={t("pl_address_2")}
                    rules={t("val_address_2")}
                    value={state?.address}
                    prefix={<Company />}
                    handleInputChange={handleInputChange}
                    max={100}
                  />
                </Col> */}

                      {/* <Col
                  xs={24}
                  sm={24}
                  md={12}
                  lg={6}
                  xl={6}
                  className="TextFeild gutter-row"
                >
                  <InputField
                    name="depo_address"
                    label={t("label_depo_address")}
                    placeholder={t("pl_depo_address")}
                    // rules={t("val_depo_address_2")}
                    nonRequiredRules={t("val_depo_address_2")}
                    pattern={"^\\d{8,9}$"} // Pattern for 8 or 9 digits
                    value={state.depo_address}
                    prefix={<Company />}
                    handleInputChange={handleInputChange}
                    max={30}
                  />
                </Col> */}

                      <Col
                        xs={24}
                        sm={24}
                        md={24}
                        lg={4}
                        xl={4}
                        className="TextFeild"
                      >
                        <Form.Item
                          name="street_address"
                          label={t("label_street_address")}
                          rules={[
                            {
                              required: true,
                              message: (
                                <Trans>{t("search_company_address")}</Trans>
                              ),
                            },
                          ]}
                        >
                          <AutoComplete
                            id="street_address"
                            placeholder={t("search_company_address")}
                            options={options}
                            // onSearch={handleSearch}
                            onSearch={(value) => {
                              const service = new window.google.maps.places.AutocompleteService();
                              if (value !== "") {
                                service.getPlacePredictions({ input: value }, (predictions, status) => {
                                  if (
                                    status === window.google.maps.places.PlacesServiceStatus.OK &&
                                    predictions
                                  ) {
                                    setOptions(
                                      predictions.map((prediction) => ({
                                        value: prediction.description,
                                        place_id: prediction.place_id,
                                      }))
                                    );
                                  } else {
                                    setOptions([]);
                                  }
                                });
                              } else {
                                setOptions([]);
                                setState((prevstate) => ({
                                  ...prevstate,
                                  street_address: "",
                                  suburb: "",
                                  state: "",
                                  postcode: "",
                                }));
                                form.setFieldsValue({
                                  street_address: "",
                                  suburb: "",
                                  state: "",
                                  postcode: "",
                                });
                              }
                            }}
                            onSelect={handleSelect}
                            value={state.street_address}
                            onChange={(value) => {
                              setState((prevstate) => ({
                                ...prevstate,
                                street_address: value,
                              }));
                              form?.setFieldsValue({
                                street_address: value,
                              });
                            }}
                          />
                        </Form.Item>
                      </Col>
                      <Col
                        xs={24}
                        sm={24}
                        md={24}
                        lg={4}
                        xl={4}
                        className="TextFeild"
                      >
                        <Form.Item
                          name="additional_details"
                          label={t("additional_details")}
                          rules={[
                            {
                              required: true,
                              message: (
                                <Trans>{t("pl_enter_additional_detail")}</Trans>
                              ),
                            },
                          ]}
                        >
                          <Input
                            placeholder={t("enter_additional_details")}
                            name="additional_details"
                            value={state.additional_details}
                            onChange={(e) => {
                              const { value } = e.target;
                              setState((prevstate) => ({
                                ...prevstate,
                                additional_details: value,
                              }));
                              form.setFieldsValue({
                                additional_details: value,
                              });
                            }}
                            // Adjust the number of rows as needed
                          />
                        </Form.Item>
                      </Col>
                      <Col
                        xs={24}
                        sm={24}
                        md={24}
                        lg={4}
                        xl={4}
                        className="TextFeild"
                      >
                        <Form.Item
                          name="suburb"
                          label={t("pl_suburb")}
                          rules={[
                            {
                              required: true,
                              message: <Trans>{t("val_suburb")}</Trans>,
                            },
                          ]}
                        >
                          <Input
                            placeholder={t("pl_enter_suburb")}
                            name="suburb"
                            value={state.suburb}
                            onChange={(e) => {
                              const { value } = e.target;
                              setState((prevstate) => ({
                                ...prevstate,
                                suburb: value,
                              }));
                              form.setFieldsValue({
                                suburb: value,
                              });
                            }}
                          />
                        </Form.Item>
                      </Col>
                      <Col
                        xs={24}
                        sm={24}
                        md={24}
                        lg={4}
                        xl={4}
                        className="TextFeild"
                      >
                        <Form.Item
                          name="state"
                          label={t("pl_state")}
                          rules={[
                            {
                              required: true,
                              message: <Trans>{t("val_state")}</Trans>,
                            },
                          ]}
                        >
                          <Input
                            placeholder={t("pl_enter_state")}
                            name="state"
                            value={state.state}
                            onChange={(e) => {
                              const { value } = e.target;
                              setState((prevstate) => ({
                                ...prevstate,
                                state: value,
                              }));
                              form.setFieldsValue({
                                state: value,
                              });
                            }}
                          />
                        </Form.Item>
                      </Col>
                      <Col
                        xs={24}
                        sm={24}
                        md={24}
                        lg={4}
                        xl={4}
                        className="TextFeild"
                      >
                        <Form.Item
                          name="postcode"
                          label={t("pl_Postcode")}
                          rules={[
                            {
                              required: true,
                              message: <Trans>{t("val_Postcode")}</Trans>,
                            },
                          ]}
                        >
                          <Input
                            placeholder={t("pl_enter_postcode")}
                            name="postcode"
                            value={state.postcode}
                            onChange={(e) => {
                              const { value } = e.target;
                              setState((prevstate) => ({
                                ...prevstate,
                                postcode: value,
                              }));
                              form.setFieldsValue({
                                postcode: value,
                              });
                            }}
                          />
                        </Form.Item>
                      </Col>
                    </Row>
                  </Panel>
                </Collapse>

                <div className="FormFooter">
                  <ButtonField
                    className="CancelGradiantBtn"
                    type="primary"
                    htmlType="button"
                    size="medium"
                    label="Cancel"
                    onClick={() => navigate("/warehouse")}
                  />
                  <ButtonField
                    className="SaveGradiantBtn"
                    type="primary"
                    htmlType="submit"
                    label="Save"
                    onClick={handleSubmit}
                    // disabled={!checked || btnLoading}
                    loading={btnLoading}
                  />
                </div>

                {/* </Form> */}
              </Spin>
            </LoadScript>
          </Form>
        </div>
      </section>
    </>
  );
};

export default Addwarehouse;
